import { limit } from 'stringz'
import accounting from 'accounting-js'
import config from './config/global.config'

export default {
  install (Vue, options) {
    Vue.filter('number', function (value, precision = 2) {
      return accounting.formatNumber(value, {
        precision
      })
    })

    Vue.filter('limit', function (value, length, pad = '') {
      return limit(value, length, pad)
    })

    Vue.filter('capitalize', function (value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    })

    Vue.filter('legacyUrl', function (value) {
      return `${config.appUrl}/${value}`
    })
  }
}
